/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useContext, useEffect } from "react";
import { AccountContext } from "./Accounts";
import {
  InputAdornment,
  makeStyles,
  TextField,
  Button,
} from "@material-ui/core";
import { useHistory, Redirect } from "react-router-dom";
import { useToast } from "../context/ToastContext";
import Pool from "../UserPool";
import CustomLoader from "./CustomLoader";
import swal from "sweetalert";
import occutraceLogo from "../svgs/OccutraceLogo.svg";
import UserIcon from "../icons/userIcons";
import PasswordIcon from "../icons/PasswordIcon";
import { CognitoUser } from "amazon-cognito-identity-js";
import { tokens } from "../theme/tokens";
const useStyle = makeStyles({
  loginFormContainer: {
    width: "315px",
    background: "#fff",
    height: "100%",
    overflow: "hidden",
    padding: "2px 55px 5px",
    boxShadow: "0px 5px 7px #00000046",
    border: `1px solid ${tokens.color.brand.primary}`,
    borderRadius: "24px",
    opacity: "1",
  },
  loginheading: {
    color: "#2E4C86",
    display: "block",
    textAlign: "center",
    paddingBottom: "5%",
    fontFamily: tokens.type.family,
  },
  inputWarp: {
    width: "100%",
    position: "relative",
    marginBottom: "7%",
    textAlign: "center",
  },
  loginInput: {
    border: `1px solid ${tokens.color.brand.primary}`,
    backgroundColor: "#eaeaea",
    boxShadow: "0px 5px 7px #00000046",
    borderRadius: "10px",
    opacity: "1",
    "& .MuiInputBase-input": {
      textIndent: "10px",
    },
    height: "28px",
    color: tokens.color.brand.primary,
    fontSize: "20px",
    paddingLeft: "2%",
  },

  loginContainer: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    background: "#ffff",
    flexDirection: "column",
  },
  imageContainer: {
    paddingBottom: "137px",
  },
  loginFields: {
    color: "#9dc8d2",
    border: `1px solid ${tokens.color.border.default}`,
    borderRadius: "10px",
    width: "320px",
    backgroundColor: tokens.color.surface.sunken,
    height: "50px",
    justifyContent: "center",
    padding: "0 10px 0 10px",
    "& .MuiFocused": {
      borderBottom: "none",
    },
    "& .MuiInput-underline::before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline::hover": {
      borderBottom: "none",
    },

    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:hover:after": {
      borderBottom: "none",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "none",
    },
    "& .MuiInput-underline": {
      borderBottom: "none",
      flexDirection: "row-reverse",
    },
    "& .MuiInputBase-input": {
      flexDirection: "row-reverse",
    },
    "& .MuiInputBase-input:hover:before": {
      borderBottom: "none",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#9dc8d2",
      fontSize: "15px",
      // fontWeight:"bold",
      fontFamily: tokens.type.family,
    },
  },
  buttonContainer: {
    textAlign: "center",
    marginTop: "138px",
  },
  button: {
    backgroundColor: tokens.color.brand.primaryAction,
    borderRadius: "25px",
    width: "170px",
    color: "white",
    //   fontSize:"1.68rem",
    fontSize: "x-large",
    textTransform: "capitalize",
    fontFamily: tokens.type.family,
    // fontWeight:"bold",
    height: "50px",
    "&:hover": {
      opacity: "0.5",
      backgroundColor: tokens.color.brand.primaryAction,
      transition: "0.2s",
    },
  },
  loginButton: {
    border: `1px solid ${tokens.color.brand.primary}`,
    borderRadius: "25px",
    width: "100px",
    background: tokens.color.brand.primary,
    color: "white",
    fontFamily: tokens.type.family,
    fontSize: "19px",
  },
  forgotPassword: {
    color: tokens.color.brand.primaryAction,
    textTransform: "capitalize",
    marginTop: "8px",
    textAlign: "center",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
});
export default (props) => {
  const classes = useStyle();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailState, setEmailState] = useState(true);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [verficationCode, setVerificationCode] = useState("");
  const [newVerifyPassword, setNewVerifyPassword] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  let history = useHistory();
  const { authenticate } = useContext(AccountContext);
  const [firstLogin, setFirstLogin] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();
  const onSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    authenticate(email, password, newPassword)
      .then((data) => {
        console.log("Logged in!", data);
        if (data.passwordChanged) {
          setPassword("");
          showToast("Password changed successfully", "success");
          setPasswordSuccess(true);
        } else if (data.isFirstLogin) {
          showToast("Change password", "info");
          setIsLoading(false);
          setFirstLogin(true);
        } else {
          localStorage.setItem("loginSuccess", true);
          window.location.reload();
        }
      })
      .catch((err) => {
        swal(
          "Oops...",
          firstLogin
            ? err.message || "Could not set the new password"
            : "Incorrect username or password",
          "error",
        );
        showToast("Login failed", "error");
        setIsLoading(false);
      });
  };

  const onForgotPassword = (e) => {
    e.preventDefault();

    var userData = {
      Username: forgotEmail,
      Pool: Pool,
    };

    var cognitoUser = new CognitoUser(userData);
    if (emailState) {
      cognitoUser.forgotPassword({
        onSuccess: function (data) {
          showToast("Verfication code send, please check your email", "success");
          setEmailState(false);
        },
        onFailure: function (err) {
          // alert(err.message || JSON.stringify(err));
          showToast(err.message || JSON.stringify(err).message, "info");
        },
      });
    } else {
      cognitoUser.confirmPassword(verficationCode, newVerifyPassword, {
        onSuccess() {
          showToast("Password reset successfully", "success");
          setForgotPassword(false);
        },
        onFailure(err) {
          showToast(err.message || JSON.stringify(err).message, "info");
        },
      });
    }
  };

  useEffect(() => {
    // setIsLoading(true);
    if (passwordSuccess === true) {
      authenticate(email, newPassword)
        .then((data) => {
          localStorage.setItem("loginSuccess", true);
          window.location.reload();
          // setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [passwordSuccess === true]);

  return (
    <div>
      <div className={classes.loginContainer}>
        {isLoading ? (
          <CustomLoader />
        ) : (
          <>
            <div className={classes.loginContainer}>
              <div className={classes.imageContainer}>
                <img src={occutraceLogo} alt="Occutrace" />
              </div>

              {forgotPassword ? (
                emailState ? (
                  <form
                    onSubmit={onForgotPassword}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div className={classes.inputWarp}>
                      <p>Please Enter your email</p>
                    </div>

                    <div className={classes.inputWarp}>
                      <TextField
                        className={classes.loginFields}
                        required={true}
                        placeholder="Email"
                        type="text"
                        onChange={(event) => setForgotEmail(event.target.value)}
                      ></TextField>
                    </div>

                    <div
                      className={classes.inputWarp}
                      style={{ marginTop: "7%" }}
                    >
                      <Button
                        className={classes.button}
                        type="submit"
                        style={{ fontSize: "1rem" }}
                      >
                        Send Code
                      </Button>
                    </div>
                  </form>
                ) : (
                  <form
                    style={{ display: "flex", flexDirection: "column" }}
                    onSubmit={onForgotPassword}
                  >
                    <TextField
                      className={classes.loginFields}
                      name="verfication"
                      onChange={(event) =>
                        setVerificationCode(event.target.value)
                      }
                      placeholder="Verfication Code"
                      required
                    ></TextField>
                    <br />
                    <TextField
                      className={classes.loginFields}
                      name="verification password"
                      placeholder="New Password"
                      required
                      type="password"
                      onChange={(event) =>
                        setNewVerifyPassword(event.target.value)
                      }
                    ></TextField>
                    <div className={classes.buttonContainer}>
                      <Button
                        className={classes.button}
                        style={{ fontSize: "1rem" }}
                        type="submit"
                      >
                        Change Password
                      </Button>
                    </div>
                  </form>
                )
              ) : firstLogin === false ? (
                <form
                  style={{ display: "flex", flexDirection: "column" }}
                  onSubmit={onSubmit}
                >
                  <TextField
                    className={classes.loginFields}
                    onChange={(event) => setEmail(event.target.value)}
                    value={email}
                    placeholder="Username"
                    inputprops={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <UserIcon />
                        </InputAdornment>
                      ),
                    }}
                  ></TextField>
                  <br />
                  <TextField
                    className={classes.loginFields}
                    placeholder="Password"
                    value={password}
                    inputprops={{
                      startAdornment: (
                        <InputAdornment position="end">
                          <PasswordIcon />
                        </InputAdornment>
                      ),
                    }}
                    type="password"
                    onChange={(event) => setPassword(event.target.value)}
                  ></TextField>
                  <span
                    className={classes.forgotPassword}
                    onClick={(e) => {
                      setForgotPassword(true);
                    }}
                  >
                    forgot password?
                  </span>
                  <div className={classes.buttonContainer}>
                    <Button className={classes.button} type="submit">
                      Login
                    </Button>
                  </div>
                </form>
              ) : (
                <form
                  onSubmit={onSubmit}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div className={classes.inputWarp}>
                    <p>
                      Since this is your first login, please set a new password
                    </p>
                  </div>

                  <div className={classes.inputWarp}>
                    <TextField
                      className={classes.loginFields}
                      placeholder="Password"
                      inputprops={{
                        startAdornment: (
                          <InputAdornment position="end">
                            <PasswordIcon />
                          </InputAdornment>
                        ),
                      }}
                      type="password"
                      onChange={(event) => setNewPassword(event.target.value)}
                    ></TextField>
                  </div>

                  <div
                    className={classes.inputWarp}
                    style={{ marginTop: "7%" }}
                  >
                    <Button
                      className={classes.button}
                      type="submit"
                      style={{ fontSize: "1rem" }}
                    >
                      Update password
                    </Button>
                  </div>
                </form>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
